import { useState } from 'react';
import { ChevronRight, FolderOpen } from 'lucide-react';
import { iconMap } from '../../../helpers/Project-Report/data/allCategories';
import { tagColors } from '../../../helpers/Project-Report/utils/helpers';
import { useWindowSize } from './useWindowSize';

const CategoryCard = ({ category, onClick }) => {
  const [hovered, setHovered] = useState(false);
  const IconComponent = iconMap[category.icon] || FolderOpen;
  const tagColor = tagColors[category.tag] || { bg: '#f1f5f9', text: '#334155' };
  const widthSize = useWindowSize();
  const isDesktop = widthSize >= 1024;

  return (
    <div
      onClick={() => onClick(category)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="flex flex-col overflow-hidden cursor-pointer bg-white rounded-2xl"
      style={{
        boxShadow: hovered
          ? '0 12px 32px rgba(0,0,0,0.12)'
          : '0 2px 10px rgba(0,0,0,0.06)',
        border: hovered ? `1.5px solid ${category.color}40` : '1.5px solid #f1f5f9',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        width: isDesktop ? '44vw' : '100vw',
      }}
    >
      {/* Top accent strip */}
      <div
        style={{
          height: hovered ? '6px' : '4px',
          background: category.gradient,
          transition: 'height 0.2s ease',
        }}
      />

      <div className="pt-5 px-5.5 pb-5.5">
        {/* Header row */}
        <div className="flex items-start justify-between mb-3.5">
          {/* Icon */}
          <div
            className="flex items-center justify-center shrink-0 w-12 h-12 rounded-[14px]"
            style={{
              background: hovered ? category.gradient : category.color,
              transition: 'background 0.25s ease',
              boxShadow: hovered ? `0 4px 14px ${category.color}50` : 'none',
            }}
          >
            <IconComponent size={22} color="#fff" strokeWidth={1.8} />
          </div>

          {/* Tag */}
          <span
            className="text-[11px] font-semibold py-1 px-2.5 rounded-[20px] tracking-[0.3px]"
            style={{
              background: tagColor.bg,
              color: tagColor.text,
            }}
          >
            {category.tag}
          </span>
        </div>

        {/* Name & description */}
        <div className="mb-4">
          <div
            className="text-[22px] font-bold mb-1.25 leading-[1.3]"
            style={{
              color: hovered ? category.color : '#0f172a',
              transition: 'color 0.2s',
            }}
          >
            {category.name}
          </div>
          <div className="text-base text-slate-400 leading-normal">
            {category.description}
          </div>
        </div>

        {/* Progress bar */}
        <div className="mb-3.5">
          <div className="flex justify-between mb-1.5">
            <span className="text-sm font-semibold" style={{ color: category.color }}>Progress</span>
            <span className="text-sm font-bold" style={{ color: category.color }}>{category.progress}%</span>
          </div>
          <div className="h-1.25 bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{
                width: `${category.progress}%`,
                background: category.gradient,
                transition: 'width 0.6s ease',
              }}
            />
          </div>
        </div>

        {/* Stats row */}
        <div className="flex items-center justify-between border-t border-slate-100 pt-3">
          <div className="flex gap-4">
            <div>
              <div className="text-[18px] font-bold text-slate-900">
                {category.totalProject}
              </div>
              <div className="text-sm text-slate-400 mt-px">Total</div>
            </div>
            <div>
              <div className="text-[18px] font-bold text-green-500">
                {category.activeProject}
              </div>
              <div className="text-sm text-slate-400 mt-px">Aktif</div>
            </div>
            <div>
              <div className="text-[18px] font-bold text-amber-500">
                {category.completedProject}
              </div>
              <div className="text-sm text-slate-400 mt-px">Selesai</div>
            </div>
          </div>

          <div
            className="flex items-center justify-center w-7 h-7 rounded-full"
            style={{
              background: hovered ? category.gradient : '#f8fafc',
              transition: 'background 0.25s',
              boxShadow: hovered ? `0 2px 8px ${category.color}40` : 'none',
            }}
          >
            <ChevronRight size={14} color={hovered ? '#fff' : '#cbd5e1'} strokeWidth={2.5} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
